import { IFilter, ISettings } from '../pr-fattura-elettronica-passiva/pr-fattura-elettronica-passiva';

export const FatturaElettronicaPassivaFilterComponent = {
  template: require('./fattura-elettronica-passiva-filter.html'),
  controller: class FatturaElettronicaPassivaFilterComponent {

    private statusList: Array<string>;
    private protocolStatusList: Array<string>;
    private settings: ISettings;
    private filterTemp: IFilter;

    private resolve: any;
    private close: any;
    private dismiss: any;

    constructor(
    ) {
      /* tslint:disable:no-string-literal */
      this.statusList = ['Ricevuta', 'Accettata', 'Rifiutata', 'Scaduta', 'Accettata dopo Scadenza', 'Rifiutata dopo Scadenza', 'Importata'];
      this.protocolStatusList = ['Da controllare', 'Controllato', 'Entrambe'];
    }

    $onInit(): void {
      this.settings = JSON.parse(JSON.stringify(this.resolve.filter));
      this.filterTemp = JSON.parse(JSON.stringify(this.settings.filter));
    }

    clearFilter() {
      this.filterTemp.status = '';
      this.filterTemp.invoice_number = '';
      this.filterTemp.annual_progressive = '';
      this.filterTemp.document_type = '';
      this.filterTemp.date_from = undefined;
      this.filterTemp.date_to = undefined;
      this.filterTemp.company_name = '';
      this.filterTemp.piva = '';
      this.filterTemp.fiscal_code = '';
      this.filterTemp.sdi_id = undefined;
      this.filterTemp.date_ricezione_from = undefined;
      this.filterTemp.date_ricezione_to = undefined;
      this.filterTemp.pageNumber = 1;
      this.filterTemp.protocol = {
        value: '',
        status: ''
      };

    }

    updateDateField(field: string, value: Date) {
      this.filterTemp[field] = value;
    }

    save() {
      this.settings.filter = this.filterTemp;
      this.close({ $value: this.settings });
    }

    cancel() {
      this.dismiss();
    }
  },
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/fattura-elettronica-passiva-filter/fattura-elettronica-passiva-filter.ts